
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1737104497254",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2727",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M786.9996875 291.9996875H737V184.6503125c0-22.3003125-2.2996875-30.350625-6.7003125-38.5003125a45.45 45.45 0 0 0-18.9-18.9c-8.1496875-4.3996875-16.2-6.7003125-38.499375-6.7003125H351.0996875c-22.299375 0-30.3496875 2.300625-38.499375 6.7003125a45.45 45.45 0 0 0-18.9 18.9c-4.400625 8.1496875-6.7003125 16.2-6.7003125 38.5003125v107.349375h-49.9996875v-93.3c0-44.5996875 4.65-60.75 13.35-76.9996875 8.7-16.35 21.4996875-29.1496875 37.8-37.8496875 16.35-8.7 32.499375-13.35 76.9996875-13.35h293.6503125c44.5996875 0 60.75 4.65 76.9996875 13.35 16.35 8.7 29.1496875 21.4996875 37.8496875 37.8 8.7 16.299375 13.35 32.499375 13.35 76.9996875v93.4003125z m-300 150v50.000625h-150A49.9996875 49.9996875 0 0 0 287 542v300a49.9996875 49.9996875 0 0 0 49.9996875 49.9996875h150v50.000625h-150A100.0003125 100.0003125 0 0 1 237.0003125 842V542a100.0003125 100.0003125 0 0 1 99.999375-100.0003125h150z",
        "p-id": "2728"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M936.9996875 492.0003125H887v-150a49.9996875 49.9996875 0 0 0-49.9996875-50.000625H186.9996875A49.9996875 49.9996875 0 0 0 137 342.0003125V542a49.9996875 49.9996875 0 0 0 49.9996875 49.9996875h50.000625v50.000625h-50.000625A100.0003125 100.0003125 0 0 1 87.0003125 542V342.0003125A100.0003125 100.0003125 0 0 1 186.9996875 242h650.000625a100.0003125 100.0003125 0 0 1 99.999375 100.0003125v150zM676.7 517.7496875c-143.1496875 0-255.4003125 78.4003125-255.4003125 178.700625s112.250625 178.65 255.4003125 178.65c143.1496875 0 255.4003125-78.350625 255.4003125-178.0003125S819.8496875 517.7496875 676.7 517.7496875z m0 307.2c-111.6 0-205.5496875-58.749375-205.5496875-128.499375S565.1496875 567.95 676.7 567.95c111.6 0 204.2503125 58.3996875 204.2503125 129.15 0 70.7503125-93 127.8496875-204.2503125 127.8496875z",
        "p-id": "2729"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M676.7 604.4496875a91.65 91.65 0 1 0-0.6496875 183.3 91.65 91.65 0 0 0 0.6496875-183.3z m0 132.8503125a41.85 41.85 0 1 1 41.5003125-40.2 41.85 41.85 0 0 1-41.5003125 40.8496875v-0.6496875zM711.9996875 342.05H812q25.0003125 0 25.0003125 25.0003125 0 24.999375-25.0003125 24.999375H711.9996875q-24.999375 0-24.999375-24.999375 0-25.0003125 24.999375-25.0003125z",
        "p-id": "2730"
      }
    }
  ]
})
    }
  